import { render, staticRenderFns } from "./POIOploc.vue?vue&type=template&id=6b1625c2"
import script from "./PoiOploc.js?vue&type=script&lang=js&external"
export * from "./PoiOploc.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports